import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListLicense from '../../components/content/list-license.component';

const LicenseManagementView = () => {
  const pageTitle = 'Manage Videos / License Management';

  return (
    <AppLayout pageTitle={pageTitle} showFilter>
      <ListLicense />
    </AppLayout>
  );
};

export default LicenseManagementView;
